import Image from 'next/legacy/image';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';

import { PlaceholderImage } from '../placeholder-image';

export const SelectedImage = ({ index, image }) => {
  const { t } = useTranslation('shared');
  const [isImageUnsupported, setIsImageUnsupported] = useState(false);

  useEffect(() => {
    setIsImageUnsupported(false);
  }, [image?.id]);

  return !image || isImageUnsupported ? (
    <div className="aspect-square flex flex-1 items-center justify-center bg-secondary-light opacity-50">
      <PlaceholderImage className="h-20 text-secondary" />
    </div>
  ) : (
    <div className="relative aspect-square">
      <Image
        src={image.url}
        alt={
          image.id === 'system-image-id'
            ? `${t('shared_imageUpload_system_alt')} (${image.originalFilename})`
            : `${t('shared_imageUpload_custom_alt')} (${image.originalFilename})`
        }
        layout="fill"
        objectFit="cover"
        priority={true}
        loader={() => image.url}
        onError={() => setIsImageUnsupported(true)}
        sizes={`(max-width: ${containerQueries.tablet}) 100vw, (max-width: ${containerQueries.desktop}) 50vw`}
        data-testid={`${image?.id}_${index}`}
      />
    </div>
  );
};
